// import { createStore } from 'vuex';
// import app from './app/app';
// import record from './record';
// import multi from './multi';
// import user from './user';

// // 创建一个新的 store 实例
// const store = createStore({
//   modules: { app, record, multi, user },
// });

// // @ts-ignore
// window.$store = store;
// export default store;
import Vue from 'vue';
import Vuex from 'vuex';

// 导入现有store模块
import app from './app/app';
import multi from './multi';
import user from './user';
import record from './record';

// 类型定义
export interface RootState {
  app: any;
  multi: any;
  user: any;
  record: any;
  editor: any;
}

// Vue 3 不再支持 Vue.use(Vuex)，请使用 createStore
import { createStore } from 'vuex';

const store = createStore<RootState>({
  modules: {
    app,
    multi,
    user,
    record,
  },
});

export default store;

